import { Navigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';

import { PublicLayout } from '../layout/public/PublicLayout';
import { checkRefreshToken } from '../redux/actions/user';

export const PublicRoute = ({ children }) => {
    const dispatch = useDispatch();
    const { isAuthenticated, loadingRefreshToken } = useSelector((state) => state.user);
    const [isCheckingAuth, setIsCheckingAuth] = useState(true);

    // console.log('PublicRouter');
    // console.log('isAuthenticated PublicRouter', isAuthenticated);

    useEffect(() => {
        const verifySession = async () => {
            // Solo verificar si no está cargando ya
            if (!loadingRefreshToken) {
                await dispatch(checkRefreshToken());
            }
            setIsCheckingAuth(false);
        };

        // Solo verificar al montar el componente
        verifySession();
    }, []); // Dependencias vacías para ejecutar solo una vez

    // Mientras verifica la autenticación, muestra un loader
    if (isCheckingAuth || loadingRefreshToken) {
        return (
            <div className="flex justify-center items-center h-screen bg-white/25">
                <div className="relative inline-flex">
                    <div className="w-16 h-16 bg-indigo-500 rounded-full"></div>
                    <div className="w-16 h-16 bg-indigo-600 rounded-full absolute top-0 left-0 animate-ping"></div>
                    <div className="w-16 h-16 bg-indigo-600 rounded-full absolute top-0 left-0 animate-pulse"></div>
                </div>
            </div>
        );
    }

    // Si está autenticado, redirige a la página principal
    if (isAuthenticated) {
        // console.log('Usuario autenticado, redirigiendo a home');
        return <Navigate to='/' replace />;
    }

    // Si no está autenticado, permite acceso a rutas públicas
    return (
        <PublicLayout>
            {children}
        </PublicLayout>
    );
};

